export const INIT_INBOX_READ = "INIT_INBOX_READ";
export const SUCCESS_INBOX_READ = "SUCCESS_INBOX_READ";
export const FAIL_INBOX_READ = "FAIL_INBOX_READ";


export const INIT_INBOX_ADMIN_TEACHER_READ = "INIT_INBOX_ADMIN_TEACHER_READ";
export const SUCCESS_INBOX_ADMIN_TEACHER_READ = "SUCCESS_INBOX_ADMIN_TEACHER_READ";
export const FAIL_INBOX_ADMIN_TEACHER_READ = "FAIL_INBOX_ADMIN_TEACHER_READ";